const puppyCharacterArr = [
    {
      charater: 'activeDogs',
      slug: 'active-dogs',
      title: 'Top Active Dog Breeds',
      text: 'Are you always on the go and looking for a canine friend to tag along with? Well, you’re in luck because here are some four-legged companions that are sure to keep up with your active lifestyle. These lovely and high-energy breeds would be glad to accompany you on any outdoor physical exercise or family adventure.',
    },
    {
      charater: 'apartmentDogs',
      slug: 'best-apartment-dogs',
      title: 'Best Apartment Dogs',
      text: "Whether you're living in a cramped apartment, condo or studio, these easygoing breeds will fit just right in. These dogs are moderately active, they don't require much exercise and would rather chill at home with you. When considering adding a new furry family member into your home, don't forget to consider the breed's energy level, noisiness, and friendliness. Explore our recommended dogs breeds for apartments and small living spaces.",
    },
    {
      charater: 'familyDogs',
      slug: 'best-family-dogs',
      title: 'Best Family Dogs',
      text: 'Choosing the perfect puppy for your family requires thoughtful consideration of your lifestyle, living condition, energy level, and children ages. You want a puppy that can keep up with your activities, has an outgoing and friendly personality and who is affectionate with the whole family. Discover the best dog breeds for your family.',
    },
    
    {
      charater: 'friendlyDogs',
      slug: 'allergy-friendly-dogs',
      title: 'Allergy Friendly Dogs',
      text: "While the American Kennel Club says there are no 100% hypoallergenic there are certain breeds that cause fewer allergy symptoms. These dogs shed significantly less than other dogs and, therefore, produce less dander (the main cause of pet allergies in humans). Explore our recommended hypoallergenic dog breeds.",
    },
    {
      charater: 'teaCupDogs',
      slug: 'teacup-puppies',
      title: 'Teacup Puppies',
      text: 'Teacup puppies are an adorable type of dog that are extra friendly and incredibly cute. Are you considering adding a teacup puppy? Read on to learn more about teacup puppies and how to choose the right one for your family.',
    },
    {
      charater: 'doodleDogs',
      slug: 'doodle-puppies',
      title: 'Doodle Puppies',
      text: 'Put simply, a Doodle dog is a crossbreed of a Poodle any other breed - that’s where we get the “oodle” in “Doodle” and the “poo” in Cockapoo, Shihpoo and Cavapoo. There are many different types of Doodles and they are known as intelligent, trainable, and affectionate pups.',
    }
  ]

  export default puppyCharacterArr